import { action, select } from 'satcheljs/lib/legacy';
import getStore from '../store/store';
import { TxpOptionState } from '../store/schema/TxpOptionState';

export interface DiscardTxpOptionState {
    optionState: TxpOptionState;
}

/**
 * Action called when we select discard in txp options page.  We reset the txp options in the store
 */
export default select<DiscardTxpOptionState>({
    optionState: () => getStore(),
})(
    action('discardTxpOption')(function discardTxpOption(state?: DiscardTxpOptionState) {
        let { optionState } = state;

        optionState.CreateEventsFromEmailAsPrivate = null;
        optionState.EventsFromEmailEnabled = null;
        optionState.Events = {
            DiningEventsFromEmailEnabled: null,
            EntertainmentEventsFromEmailEnabled: null,
            FlightEventsFromEmailEnabled: null,
            HotelEventsFromEmailEnabled: null,
            InvoiceEventsFromEmailEnabled: null,
            PackageDeliveryEventsFromEmailEnabled: null,
            RentalCarEventsFromEmailEnabled: null,
            ServiceAppointmentEventsFromEmailEnabled: null,
        };
        optionState.EntityTypeProcessorLevelSettings = {
            FlightReservation: null,
            FoodEstablishmentReservation: null,
            LodgingReservation: null,
            RentalCarReservation: null,
            ParcelDelivery: null,
            EventReservation: null,
            Invoice: null,
            ServiceReservation: null,
        };
    })
);
